import { Icon, type IconName } from '../Icon.js';

/**
 * A ponte de ícones dos primitivos.
 *
 * Os arquivos desta pasta vêm do shadcn e importam `lucide-react`. Instalar
 * o lucide resolveria a compilação e criaria o problema de verdade: duas
 * famílias de ícone na mesma tela, com espessuras e grades diferentes, que é
 * exatamente o que `Icon` existe para não deixar acontecer.
 *
 * Então os nomes do lucide continuam existindo — só que desenhados pela nossa
 * grade de 24. `make ui-primitivo` troca `from './icons.js'` por este
 * arquivo, e um primitivo novo chega adaptado sem ninguém lembrar de nada.
 *
 * Um nome aqui só entra quando um primitivo pede. Não é catálogo.
 */
function ofGrid(nome: IconName) {
  function Glyph({ className }: { className?: string }) {
    // 16px é o tamanho que o shadcn assume para ícone dentro de controle
    // (`[&_svg:not([class*='size-'])]:size-4`); declarar aqui evita o pulo
    // entre o que o React pinta e o que o CSS corrige depois.
    return <Icon nome={nome} size={16} className={className} />;
  }
  Glyph.displayName = `Glifo(${nome})`;
  return Glyph;
}

export const CheckIcon = ofGrid('confirmado');
export const XIcon = ofGrid('fechar');
export const CircleIcon = ofGrid('ponto');
export const ChevronRightIcon = ofGrid('seta-direita');
export const ChevronDownIcon = ofGrid('seta-baixo');
export const ChevronUpIcon = ofGrid('seta-cima');
